module.exports = __webpack_public_path__ + "static/banner.04cdb110.png";